import ClubExamSettings from '../../dto/club/ClubExamSettings';
import Error from '../../model/Error';
import axios from 'axios';

export default class ClubExamSettingsRepository {

    static findByClubId(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/exams/settings`)
                .then(response => resolve(ClubExamSettings.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        })
    }

    static update(clubId, clubExamSettings) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/clubs/${clubId}/exams/settings`, clubExamSettings)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
